import axios from "axios";
import { resolveApiBaseUrl } from "./baseUrl";

export const api = axios.create({
  baseURL: resolveApiBaseUrl(process.env.NODE_ENV, process.env.REACT_APP_API_BACKEND),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;

    if (status === 401) {
      console.error("Requisicao nao autorizada:", err.config?.url);
      const detail = {
        source: "api",
        url: err.config?.url || null,
      };
      document.dispatchEvent(new CustomEvent("app:unauthorized", { detail }));
    } else if (status === 429) {
      const retryAfter = err?.response?.headers?.["retry-after"] || null;
      const detail = {
        source: "api",
        url: err.config?.url || null,
        retryAfter,
      };
      document.dispatchEvent(new CustomEvent("app:rate-limit", { detail }));
      console.warn("Limite de requisicoes atingido:", detail);
    } else if (!err?.config?.suppressErrorLog) {
      console.error("Erro na API:", err);
    }
    return Promise.reject(err);
  }
);
